import { formatCurrency } from "@angular/common";
import { AfterViewInit, Component, Input } from "@angular/core";
import { UniChartOptions } from "@universal-ui";

import locales from "@assets/graph/locales.json";

import { PorfolioDistribution } from "../../Types/Interfaces/portfolio-distribution.interface";

@Component({
  selector: "app-balances-graphic",
  templateUrl: "./balances-graphic.component.html",
})
export class BalancesGraphicComponent implements AfterViewInit {
  public series: ApexAxisChartSeries | ApexNonAxisChartSeries = [];
  public colors = ["#74B2F4", "#4C7EED", "#3A5879", "#80A4F7", "#B9CB87", "#74B204", "#EFCF6E"];
  public labels: string[];

  private _balances: PorfolioDistribution[];

  public readonly title = "Gráfico de Distribución de Cartera por Producto";

  @Input() public set balances(agingBalance: PorfolioDistribution[]) {
    if (agingBalance) {
      this._balances = agingBalance;
      const balanceValues = agingBalance.map(({ axisY }) => +axisY);
      this.series = balanceValues;
      this.labels = agingBalance.map(({ axisX }) => axisX);
      this.setChartOptions();
    }
  }

  public chartOptions: Partial<UniChartOptions> = {};

  public ngAfterViewInit(): void {
    this.setChartOptions();
  }

  public setChartOptions(): void {
    this.chartOptions = {
      chart: {
        ...this.chartOptions?.chart,
        type: "donut",
        locales: [locales.es],
        defaultLocale: "es",
        toolbar: {
          export: {
            csv: {
              filename: this.title,
              headerCategory: "Período",
            },
            png: {
              filename: this.title,
            },
            svg: {
              filename: this.title,
            },
          },
        },
        height: 500,
      },
      colors: this.colors,
      plotOptions: {
        pie: {
          customScale: 0.95,
        },
      },
      dataLabels: {
        enabled: true,
      },
      legend: {
        show: true,
        position: "bottom",
        fontSize: "13px",
      },
      yaxis: {
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      xaxis: {
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (value) {
            return formatCurrency(value, "en-US", "$", "DOP");
          },
        },
      },
      series: this.series,
      labels: this.labels,
    };
  }
}
